import React, { useEffect, useMemo, useState } from "react";
import "./BattleCard.css";
import ThemedCardComponent from "../../../genericComponents/themedCardCompoennt";
import { useDispatch, useSelector } from "react-redux";
import { fetchPitchWoCardRequest } from "../../../../../store/features/actions/opportunities/pitchCardWOActions";
import { useParams } from "react-router-dom";
import NoDataComp from "../../../genericComponents/uiElements/NoDataComp";
import GenericTable from "../../../genericComponents/genericTableComp/GenericTable";
import "./PitchCard.css";

const beautifyKey = (key) => {
  return key
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, (l) => l.toUpperCase()); // Capitalize each word
};

const renderContentValue = (value, depth = 0) => {
  const indent = { marginLeft: `${depth * 1}rem`, marginTop: "0.5rem" };

  if (typeof value === "string" || typeof value === "number") {
    return <div style={{ ...indent }}>{value}</div>;
  }

  if (Array.isArray(value)) {
    const isArrayOfObjects = value.every(
      (v) => typeof v === "object" && !Array.isArray(v)
    );

    return (
      <div style={{ ...indent }}>
        {isArrayOfObjects
          ? value.map((obj, idx) => (
              <div key={idx} style={{ marginBottom: "1rem" }}>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "1rem",
                    marginBottom: "0.5rem",
                  }}
                >
                  {Object.entries(obj).map(([key, val]) => (
                    <div key={key} style={{ minWidth: "200px" }}>
                      <span style={{ fontWeight: 500 }}>
                        {beautifyKey(key)}:
                      </span>{" "}
                      <span style={{ fontWeight: 300 }}>{val}</span>
                    </div>
                  ))}
                </div>
                <hr style={{ borderTop: "1px solid #ccc" }} />
              </div>
            ))
          : value.map((item, idx) => (
              <div key={idx} style={{ marginLeft: "1rem" }}>
                • {renderContentValue(item, depth + 1)}
              </div>
            ))}
      </div>
    );
  }

  if (typeof value === "object" && value !== null) {
    return (
      <div style={indent}>
        {Object.entries(value).map(([key, val]) => (
          <div key={key} style={{ marginBottom: "0.5rem" }}>
            <span style={{ fontWeight: 500 }}>{beautifyKey(key)}:</span>{" "}
            <span style={{ fontWeight: 300 }}>
              {renderContentValue(val, depth + 1)}
            </span>
          </div>
        ))}
      </div>
    );
  }

  return null;
};

export default function PitchCard({ opportunityId }) {
  const dispatch = useDispatch();
  const { pitchWoData, pitchWoLoading } = useSelector(
    (state) => state.pitchWoReducer
  );
  console.log("pitchWoData", pitchWoData);
  const [rowData, setRowData] = useState([]);
  const [tabData, setTabData] = useState([]);

  // Set row data from Redux on update
  useEffect(() => {
    if (Array.isArray(pitchWoData?.[0]?.records?.pitch_structure)) {
      setRowData(pitchWoData[0].records?.pitch_structure);
    }else{
       setRowData([]);
    }
  }, [pitchWoData]);
  console.log("rowData", rowData);
  // Enhance table data after rowData is set
  useEffect(() => {
    if (!rowData || rowData.length === 0) return;

    const enhanced = rowData.map((item) => ({
      ...item,
      segment: (
        <div style={{ all: "unset", fontWeight: 300 }}>{item.segment}</div>
      ),
      content: (
        <div style={{ whiteSpace: "pre-wrap", fontWeight: 300 }}>
          {renderContentValue(item.content)}
        </div>
      ),
    }));

    setTabData(enhanced);
  }, [rowData]);

  // Initial fetch
  useEffect(() => {
    if (opportunityId?.length > 0) {
      dispatch(fetchPitchWoCardRequest({ opportunityId }));
    }
  }, [opportunityId]);

  const tableColumns = useMemo(
    () => [
      { id: "time", label: "Time Stamp", width: 30 },
      { id: "section", label: "Segment", width: 30 },
      { id: "content", label: "Seller Script", width: 120 },
    ],
    []
  );

  if (!rowData || (rowData.length === 0 && !pitchWoLoading)) {
    return (
      <div className="mt-2">
        <NoDataComp
          buttonText={"Refresh"}
          message="Data is being generated"
          onButtonClick={(e) => {
            e.preventDefault();
            dispatch(fetchPitchWoCardRequest({ opportunityId }));
          }}
        />
      </div>
    );
  }

  return (
    <div
      className="find-opportunities-results-container mt-2 p-2"
      style={{ fontWeight: 300 }}
    >
      <GenericTable
        initialColumns={tableColumns}
        tabData={tabData}
        loading={pitchWoLoading}
        disableSort={true}
      />
    </div>
  );
}
